/**
 * Shared validation constants used by BOTH client (SPA) and server (Lambda).
 *
 * Centralizing field-length limits and upload format/size rules here keeps
 * client-side validation and server-side validation in lock-step, so the two
 * can never drift (Req 14.4, 4.2, 4.3, 8.2, 8.3).
 */
/** Maximum character length for each free-text booking field. */
export const FIELD_LIMITS = {
    /** Client display name on a booking inquiry. */
    clientName: 100,
    /** Client email address. */
    clientEmail: 254,
    /** Free-text message body on a booking inquiry. */
    message: 2000,
    /** FAQ question text. */
    faqQuestion: 300,
    /** FAQ answer text. */
    faqAnswer: 5000,
    /** A single payment-method label, e.g. "Cash App". */
    paymentLabel: 50,
};
/** One mebibyte in bytes. */
export const ONE_MIB = 1024 * 1024;
/**
 * Image upload rules for portfolio images.
 *
 * `supportedFormats` lists the allowed MIME content types; `maxSizeBytes`
 * is the hard upper bound. Validation accepts iff format is in the allowlist
 * AND size <= maxSizeBytes (Req 4.2, 4.3).
 */
export const IMAGE_UPLOAD = {
    /** Allowlisted upload content types (MIME). */
    supportedFormats: ["image/jpeg", "image/png", "image/webp"],
    /** Maximum accepted upload size in bytes (15 MiB). */
    maxSizeBytes: 15 * ONE_MIB,
};
/**
 * Pragmatic email format pattern. Intentionally simple and robust: a single
 * "@", non-empty local and domain parts, and at least one dot in the domain.
 * Full RFC 5322 validation is neither necessary nor desirable here.
 */
export const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
/** Pattern for an ISO calendar date with no time component: YYYY-MM-DD. */
export const ISO_DATE_PATTERN = /^\d{4}-\d{2}-\d{2}$/;
//# sourceMappingURL=constraints.js.map